import APP_CONST from '../../constants';
import SsoCompletePage from './sso-complete';
import { ROUTER_CONST, $state } from '../../router';

export default {
    name: 'complete-sso',
    url: '/complete-sso?{code}{error_description}',
    component: SsoCompletePage,
    layout: APP_CONST.LAYOUT_PARTIAL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PROTECTED,
    resolve: [{   
            token: 'check',
            deps: ['$transition$'],
            resolveFn: (trans) => {
                if (!trans.params().code && !trans.params().error_description) {
                    $state.go('login');
                    return false;
                }
            return true;
        }
    }]
};
